import React, { useRef, useEffect, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import "./index.less";
import { adaptSize } from '../../utils/remAdapter'

import ringImg from '../../assets/newVersion/logos2.png';
import circleImg from '../../assets/newVersion/logos1.png';
import triangleImg from '../../assets/newVersion/logos3.png';
import feiji from '../../assets/newVersion/feiji.png';

import Positioning from '../../assets/newVersion/Positioning.svg';
import Navigation from '../../assets/newVersion/Navigation.svg';
import Route from '../../assets/newVersion/Route.svg';
import Map from '../../assets/newVersion/Map.svg'

import mouse from '../../assets/newVersion/mouse.svg';
import buildingImg from '../../assets/newVersion/first-second-bg.avif';
import logoAnimation from '../../assets/newVersion/logo-animation.png'
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

// 可配置：自动轮播间隔（毫秒）
const AUTOPLAY_INTERVAL = 1000;

// 第三屏数据配置
const TECH_ITEMS = [
  { num: '01', title: '定位', img: Positioning, className: 'Positioning' },
  { num: '02', title: '导航', img: Navigation, className: 'Navigation' },
  { num: '03', title: '路线', img: Route, className: 'Route' },
  { num: '04', title: '地图', img: Map, className: 'Map' },
];

const Home: React.FC = () => {
  const section2Ref = useRef<HTMLDivElement>(null);
  const section2LeftRef = useRef<HTMLDivElement>(null);
  const rightContainerRef = useRef<HTMLDivElement>(null);
  const trailRef = useRef<SVGPathElement>(null);
  const textBoxRef = useRef<HTMLDivElement>(null);
  const dotsRef = useRef<(HTMLDivElement | null)[]>([]);

  const firstSectionRef = useRef<HTMLDivElement>(null);
  const logoBoxRef = useRef<HTMLDivElement>(null);
  const logosContainerRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const msgRef = useRef<HTMLDivElement>(null);

  // 第三屏自动轮播状态
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const autoplayRef = useRef<NodeJS.Timeout | null>(null);

  // 第一屏动画（保持原有逻辑）
  useEffect(() => {
    const logoBox = logoBoxRef.current;
    const logosContainer = logosContainerRef.current;
    if (!logoBox || !logosContainer) return;

    const circleCenter = { x: 278, y: 95 };
    const radius = 112;
    const pathPoints = [];

    const dShape = [
      { x: 80, y: -68, rotation: -6 }, { x: 70, y: -70, rotation: -12 },
      { x: 60, y: -72, rotation: -18 }, { x: 50, y: -76, rotation: -24 },
      { x: 40, y: -78, rotation: -30 }, { x: 30, y: -80, rotation: -30 },
      { x: 0, y: -80, rotation: -30 }, { x: -30, y: -80, rotation: -30 },
      { x: -50, y: -80, rotation: -120 }, { x: -80, y: -80, rotation: -120 },
      { x: -80, y: -60, rotation: -120 }, { x: -80, y: -30, rotation: -120 },
      { x: -80, y: 0, rotation: -120 }, { x: -80, y: 30, rotation: -120 },
      { x: -80, y: 60, rotation: -120 }, { x: -80, y: 90, rotation: -120 },
      { x: -80, y: 120, rotation: -120 }, { x: -80, y: 150, rotation: -120 },
      { x: -80, y: 180, rotation: -120 }, { x: -80, y: 190, rotation: -120 },
      { x: -80, y: 200, rotation: -120 }, { x: -80, y: 210, rotation: -120 },
      { x: -50, y: 210, rotation: -120 }, { x: -20, y: 210, rotation: -120 },
      { x: 10, y: 210, rotation: -120 }, { x: 30, y: 210, rotation: -120 },
      { x: 40, y: 210, rotation: -210 }, { x: 45, y: 208, rotation: -211 },
      { x: 50, y: 206, rotation: -212 }, { x: 60, y: 204, rotation: -213 },
      { x: 70, y: 201, rotation: -214 }, { x: 80, y: 196, rotation: -220 },
      { x: 100, y: 185, rotation: -226 }, { x: 111, y: 176, rotation: -227 },
      { x: 121, y: 167, rotation: -238 }, { x: 126, y: 162, rotation: -245 },
      { x: 130, y: 158, rotation: -265 }, { x: 138, y: 149, rotation: -270 },
      { x: 145, y: 140, rotation: -275 }, { x: 151, y: 131, rotation: -280 },
      { x: 156, y: 122, rotation: -285 }, { x: 160, y: 113, rotation: -290 },
      { x: 163, y: 104, rotation: -295 }, { x: 166, y: 95, rotation: -300 },
    ];
    pathPoints.push(dShape);
    pathPoints.push([])
    const steps = 420;
    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      const angleDeg = 180 + t * 360;
      const angleRad = angleDeg * (Math.PI / 180);
      pathPoints[1].push({
        x: circleCenter.x + radius * Math.cos(angleRad),
        y: circleCenter.y + radius * Math.sin(angleRad),
        rotation: (angleDeg + 60)
      });
    }
    const dShape2 = [
      { x: 166, y: 95, rotation: 60 }, { x: 160, y: 40, rotation: 52 },
      { x: 153, y: 10, rotation: 45 }, { x: 147, y: 0, rotation: 38 },
      { x: 140, y: -10, rotation: 32 }, { x: 135, y: -20, rotation: 25 },
      { x: 125, y: -30, rotation: 18 }, { x: 115, y: -40, rotation: 12 },
      { x: 100, y: -55, rotation: 6 }, { x: 90, y: -62, rotation: 0 },
    ]
    pathPoints.push(dShape2);

    const motionPathData = pathPoints.map(p => {
      return p.map(i => ({
        x: adaptSize(i.x),
        y: adaptSize(i.y),
        rotation: i.rotation
      }))
    });

    gsap.set(logosContainer, {
      x: motionPathData[0][0].x,
      y: motionPathData[0][0].y,
      rotation: -6,
    })
    gsap.set(logoBox, { opacity: 0 });

    const tl = gsap.timeline({ delay: 0.5 });
    tl.fromTo(".box", { opacity: 0 }, {
      opacity: 1,
      ease: "back.out(1.7)",
      stagger: { amount: .5, from: "start" }
    });
    tl.to(logoBox, { opacity: 1, ease: "power2.out", duration: .5 })
      .to('.f-title', { opacity: 1, duration: .5 }, 'title')
      .to('.f-msg', { opacity: 1, duration: 1 }, 'title')
      .to('.learn-more', { opacity: 1, duration: 1.5 }, 'title')
      .to(logosContainer, {
        motionPath: {
          path: motionPathData[0],
          curviness: 1.5,
          autoRotate: false,
          useRadians: false
        },
        duration: 3,
        ease: "none",
        onUpdate: function () {
          const progress = this.progress();
          const totalPoints = motionPathData[0].length;
          const exactIndex = progress * (totalPoints - 1);
          const index = Math.floor(exactIndex);
          const nextIndex = Math.min(index + 1, totalPoints - 1);
          const segmentProgress = exactIndex - index;
          const curr = motionPathData[0][index];
          const next = motionPathData[0][nextIndex];
          const rotation = curr.rotation + (next.rotation - curr.rotation) * segmentProgress;
          gsap.set(logosContainer, { rotation });
        }
      }, 'title')
      .to(logosContainer, {
        motionPath: { path: motionPathData[1], curviness: 1.5 },
        duration: 3.5,
        ease: "none",
      }, 'circle')
      .to(logosContainer, { rotation: 60, duration: 3.5, ease: "none" }, 'circle')
      .to(logosContainer, {
        motionPath: {
          path: motionPathData[2],
          curviness: 1.5,
          autoRotate: false,
          useRadians: false
        },
        duration: 1,
        ease: "none",
        onUpdate: function () {
          const progress = this.progress();
          const totalPoints = motionPathData[2].length;
          const exactIndex = progress * (totalPoints - 1);
          const index = Math.floor(exactIndex);
          const nextIndex = Math.min(index + 1, totalPoints - 1);
          const segmentProgress = exactIndex - index;
          const curr = motionPathData[2][index];
          const next = motionPathData[2][nextIndex];
          const rotation = curr.rotation + (next.rotation - curr.rotation) * segmentProgress;
          gsap.set(logosContainer, { rotation });
        }
      });

    return () => { tl.kill(); };
  }, []);

  // 第二屏动画（保持原有逻辑）
  useEffect(() => {
    const section2 = section2Ref.current;
    const rightContainer = rightContainerRef.current;
    const textBox = textBoxRef.current;
    const trailPath = trailRef.current;
    if (!section2 || !rightContainer || !textBox) return;

    const finalWidth = 1189;
    const finalLeft = 734;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section2,
        start: "top 60%",
        end: "top 10%",
        scrub: 1.5,
        once: true,
      }
    });

    tl.fromTo(rightContainer,
      { width: adaptSize("1920px"), left: "0px" },
      { width: adaptSize(finalWidth), left: adaptSize(`${finalLeft}px`), ease: "none" }, 0
    );
    tl.fromTo('.building-bg',
      { objectPosition: `0 0` },
      { objectPosition: `${adaptSize('-625px')} 0px`, ease: "none" }, 0
    );
    tl.fromTo(textBox,
      { x: adaptSize(80), opacity: 0 },
      { x: 0, opacity: 1, ease: "power2.out" }, 0.1
    );
    tl.fromTo(section2LeftRef.current,
      { opacity: 0 },
      { opacity: 1, ease: "power2.out" }, 0.5
    );
    tl.fromTo(textBoxRef.current,
      { x: adaptSize(500) },
      { x: 0, ease: "power2.out" }, 0.5
    );
    if (trailPath) {
      const pathLength = trailPath.getTotalLength();
      gsap.set(trailPath, { strokeDasharray: pathLength, strokeDashoffset: pathLength, opacity: 0 });
      tl.fromTo(trailPath,
        { strokeDashoffset: pathLength, opacity: 0 },
        { strokeDashoffset: 0, opacity: 0.5, ease: "none" }, 0
      );
    }
    dotsRef.current.forEach((dot, i) => {
      if (!dot) return;
      const startTime = i * 0.22;
      tl.fromTo(dot, { scale: 0, opacity: 0 }, { scale: 1, opacity: 0.7, duration: 0.1, ease: "back.out(1.7)" }, startTime);
    });
  }, []);

  // 第三屏自动轮播逻辑
  useEffect(() => {
    // 如果正在 hover，停止轮播
    if (isHovering) {
      if (autoplayRef.current) clearInterval(autoplayRef.current);
      return;
    }

    // 启动自动轮播
    autoplayRef.current = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % TECH_ITEMS.length);
    }, AUTOPLAY_INTERVAL);

    return () => {
      if (autoplayRef.current) clearInterval(autoplayRef.current);
    };
  }, [isHovering]);

  // 第三屏事件处理
  const handleMouseEnter = (index: number) => {
    setIsHovering(true);
    setActiveIndex(index); // hover 后立即切换到当前
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    // 移出时立即播放下一个（符合"移出的时候播放下一个"）
    // 如果不需要立即切换，而是等待3秒后再切换，请删除下面这行
    setActiveIndex(prev => (prev + 1) % TECH_ITEMS.length);
  };

  return (
    <div className="home-page">
      {/* 第一屏 */}
      <div className="scroll-first" ref={firstSectionRef}>
        <div className="logo-box" ref={logoBoxRef}>
          <div className="logos-container" ref={logosContainerRef}>
            <img src={logoAnimation} className="logo-animation" alt="logo" />
          </div>
        </div>
        <svg className="divider-box" fill="none" version="1.1" width="519" height="5" viewBox="0 0 519 5">
          <defs>
            <linearGradient x1="0" y1="0.5" x2="1" y2="0.5" id="master_svg0_135_06782">
              <stop offset="0%" stopColor="#FFFFFF" stopOpacity="1" />
              <stop offset="100%" stopColor="#FFFFFF" stopOpacity="1" />
              <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
            </linearGradient>
            <mask id="master_svg1_135_06761" maskUnits="userSpaceOnUse" x="0" y="0" width="519" height="5">
              <rect x="0" y="0" width="519" height="5" rx="0" fill="url(#master_svg0_135_06782)" fillOpacity="0.5" />
            </mask>
          </defs>
          <g mask="url(#master_svg1_135_06761)">
            <rect className="box" x="0" y="0" width="5" height="5" rx="0" fill="#FFFFFF" fillOpacity="1" />
            <rect className="box" x="140" y="0" width="5" height="5" rx="0" fill="#FFFFFF" fillOpacity="1" />
            <rect className="box" x="160" y="0" width="5" height="5" rx="0" fill="#FFFFFF" fillOpacity="0.30000001192092896" />
            <rect className="box" x="280" y="0" width="5" height="5" rx="0" fill="#FFFFFF" fillOpacity="0.6000000238418579" />
            <rect className="box" x="325" y="0" width="5" height="5" rx="0" fill="#FFFFFF" fillOpacity="1" />
            <rect className="box" x="341" y="0" width="5" height="5" rx="0" fill="#FFFFFF" fillOpacity="0.30000001192092896" />
            <rect className="box" x="414" y="0" width="5" height="5" rx="0" fill="#FFFFFF" fillOpacity="0.30000001192092896" />
            <rect className="box" x="440" y="0" width="5" height="5" rx="0" fill="#FFFFFF" fillOpacity="1" />
            <rect className="box" x="514" y="0" width="5" height="5" rx="0" fill="#FFFFFF" fillOpacity="1" />
          </g>
        </svg>
        <div className="f-title" ref={titleRef}>
          <div className="text">驾驶未来</div><div className="doit">·</div><div className="text">全新出行</div>
        </div>
        <div className="f-msg" ref={msgRef}>科技引领·驾驶无界·自在出行·解放双手</div>
        <Link className="learn-more" to="/smart-travel">了解更多</Link>
        <img src={mouse} alt="" className="mouse" />
      </div>

      {/* 第二屏 */}
      <div className="scroll-second" ref={section2Ref}>
        <div className="left" ref={section2LeftRef}>
          <div className="text-box" ref={textBoxRef}>
            <div className="title">助力企业<br />数智升级</div>
            <div className="msg">海量人地大数据、定制化开发企业服务，赋能决策</div>
            <Link className="btn" to="/enterprise">了解更多</Link>
          </div>
        </div>
        <div className="right" ref={rightContainerRef}>
          <div className="right-box">
            <img src={buildingImg} alt="building" className="building-bg" />
          </div>
        </div>
      </div>

      {/* 第三屏 - 自动轮播改造 */}
      <div className="scroll-third">
        <div className="left">
          <div className="bg-img"></div>
          <div className="square"></div>
          <div className="title">聚焦<span className="caise">四大</span>核心技术</div>
          <div className="msg">
            定位<div className="xiantiao"></div>
            导航<div className="xiantiao"></div>
            地图<div className="xiantiao"></div>
            路线
          </div>
          <Link className="btn" to="/about">了解更多</Link>
        </div>
        <div className="right">
          {TECH_ITEMS.map((item, index) => (
            <Link 
              to="/about" 
              key={item.num}
              className={`right-item ${activeIndex === index ? 'active' : ''}`}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              <div className="num">{item.num}</div>
              <div className="item-content">
                <div className="item-title">{item.title}</div>
                <img src={item.img} className={`desc ${item.className}`} alt={item.title} />
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* 第四屏 */}
      <div className="scroll-fourth">
        <div className="scroll-fourth-title">始于信任<i />成于技术</div>
      </div>
    </div>
  );
};

export default Home;